<template>
  <a v-if="bandera == 0">
    <div class="stCard cartaInfo">
      <b-card no-body class="overflow-hidden">
        <b-row no-gutters>

          <!--
          <b-col md="2">
            <b-avatar class="m-4" size="5em">{{
              $parent.usuarioActivo.nombres
            }}</b-avatar>
          </b-col>
          -->
          <div class="cabecera d-inline-flex align-items-center">

          </div>

          <b-col md="10">
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <div class="col-md-6">
                    <img src="https://eservicios2.aguascalientes.gob.mx/portalgea/iconos/i_hombre.svg" alt="icono"
                      class="img-fluid" align="center">
                    <h2 class="subtitulo">Datos de la Cuenta</h2>
                    <p>
                      <b>Nombre: </b>{{
                        $parent.usuarioActivo.nombres +
                        " " +
                        $parent.usuarioActivo.apellidop +
                        " " +
                        $parent.usuarioActivo.apellidom
                      }}
                    </p>
                    <p>
                      <b>Usuario/CURP: </b>{{ $parent.usuarioActivo.usuario }}
                    </p>
                    <p>
                      <b>Nivel Académico: </b>{{ $parent.usuarioActivo.preparacion }}
                    </p>
                    <p>
                      <b>Teléfono Móvil: </b>{{ $parent.usuarioActivo.telefono }}
                    </p>
                    <p>
                      <b>Correo electrónico: </b>{{ $parent.usuarioActivo.email }}
                    </p>

                    <p v-if="$parent.usuarioActivo.perfil">
                      <b>Perfil: </b>{{ $parent.usuarioActivo.perfil_descripcion }}
                    </p>

                    <a @click="editarperfil()" class="btn bg-2">Editar información</a>

                  </div>

                  <div class="col-md-6">

                    <h2 class="subtitulo">Tus Avances</h2>

                    <pie-chart-component v-if="cursosTotal" :chartData="chartdata" :options="options" />
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </a>


  <div v-else>
    <center>

      <b-col md="10">
        <b-card-body>
          <b-card-text>
            <div class="row">
              <div class="col-md-6">
                <h2 class="subtitulo">Datos de la Cuenta</h2>
                <p>
                  <b>Nombre: </b>{{
                    $parent.usuarioActivo.nombres +
                    " " +
                    $parent.usuarioActivo.apellidop +
                    " " +
                    $parent.usuarioActivo.apellidom
                  }}
                </p>
                <p>
                  <b>Usuario/CURP: </b>{{ $parent.usuarioActivo.usuario }}
                </p>



                <p> <b> Nivel Académico: {{ preparacion }} </b>
                  <input type="text" v-model=preparacion id="preparacion"
                    oninput="this.value = this.value.toUpperCase().replace(/[^A-Z .]/g, '')" />
                </p>



                <p> <b> Teléfono Móvil: {{ telefono }} </b>
                  <input type="text" v-model=telefono id="telefono" maxlength="10"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '')" />

                </p>

                <p> <b> Correo Electrónico: {{ email }} </b>
                  <input type="text" v-model=email id="email"
                    oninput="this.value = this.value.toLowerCase().replace(/[^a-z]/g, '')"  disabled/>
                </p>


                <p v-if="$parent.usuarioActivo.perfil">
                  <b>Perfil: </b> {{ $parent.usuarioActivo.perfil_descripcion }}
                </p>

                <a @click="guardado()" class="btn bg-4">Guardar ✓</a>
                <a @click="cancelar()" class="btn bg-2">Cancelar X</a>

              </div>
            </div>
          </b-card-text>
        </b-card-body>

      </b-col>

    </center>
  </div>
</template>

<script>
//import axios from "axios";
import PieChartComponent from "../graficas/PieChartComponent.vue";
import { queryIEASIS } from '../backIeasis/dbContextConexion';
import { alert } from "@/assets/functions";

export default {
  components: { PieChartComponent },
  name: "PerfilComponent",
  data() {
    return {
      bandera: 0, //Bandera para renderización para editar inf. perfil
      preparacion: "",
      telefono: "",
      email: "",

      eficiencia: {
        concluido: 0,
        noConcluido: 0,
        pendiente: 0,
      },

      cursosTotal: 0,
      usuario: {},
      chartdata: {
        labels: ["Concluidos: 0", "No Concluidos: 0", "Pendientes: 0"],
        datasets: [
          {
            backgroundColor: ["#ADD698", "#D65D5D", "#f2cb52"],
            data: [0, 0, 0],
          },
        ],
      },
      options: { responsive: true, maintainAspectRatio: false },
    };
  },
  mounted() {
    
  },

  async beforeMount() {

    

    //const query= "SELECT idusuario,resultado, COUNT(resultado) as cuenta FROM registros where idusuario = 25 GROUP BY idusuario, resultado"
    const query = "SELECT idusuario,resultado, COUNT(resultado) as cuenta FROM registros where idusuario = " + sessionStorage.getItem("id") + " GROUP BY idusuario, resultado"
    const res = await queryIEASIS(query)


    if (res) {
      console.log('REGISTROS', res)
      if (res.length) {
        res.forEach((el) => {
          switch (el.resultado) {
            case "CONCLUIDO":
              this.eficiencia.concluido = el.cuenta;
              this.chartdata.datasets[0].data[0] = el.cuenta
              this.chartdata.labels[0] = `Concluidos: ${el.cuenta}`
              break;
            case "NO CONCLUIDO":
              this.eficiencia.noConcluido = el.cuenta;
              this.chartdata.datasets[0].data[1] = el.cuenta;
              this.chartdata.labels[1] = `No Concluidos: ${el.cuenta}`
              break;
            case "PENDIENTE":
              this.eficiencia.pendiente = el.cuenta;
              this.chartdata.datasets[0].data[2] = el.cuenta;
              this.chartdata.labels[2] = `Pendientes: ${el.cuenta}`
              break;
          }
          this.cursosTotal += el.cuenta;
        })
      }
    }

    console.log('bandera:', this.bandera)
  },

  methods: {
    async editarperfil() {
      this.bandera = 1;
      this.preparacion = this.$parent.usuarioActivo.preparacion;
      this.telefono = this.$parent.usuarioActivo.telefono;
      this.email = this.$parent.usuarioActivo.email;
    },
    async guardado() {

      if (!this.email || !this.preparacion || !this.email.includes("@iea.edu.mx")) {
        alert('ERROR: VERIFICA LOS DATOS INGRESADOS', 'danger')
        return;
      }
      else if (!this.email.includes("@iea.edu.mx")) {
        alert(
          `El correo Ingresado"${this.email}" NO corresponde al institucional del dominio @iea.edu.mx`, 'danger'
        )
        return;
      }
      else {
        const query = "UPDATE usuarios SET telefono = '" + this.telefono + "' , " + " email = " + "'" + this.email + "' , " + "preparacion = " + "'" + this.preparacion + "'" + " WHERE idusuario = " + sessionStorage.getItem('id');
        const res = await queryIEASIS(query);
        if (res) {
          alert("¡Datos Actualizados!", 'success');
        } else {
          alert("¡Hubo un problema al actualizar los Datos, verifique su información!", 'danger');
        }
        this.bandera = 0;
        window.location.reload();
      }

    },
    cancelar() {
      this.bandera = 0;
    }
  },


};
</script>
